// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__2oRw1","menuBrand":"Navbar_menuBrand__1bLYW"};